import { render, staticRenderFns } from "./seminar.vue?vue&type=template&id=ebfcea2c"
import script from "./seminar.vue?vue&type=script&lang=js"
export * from "./seminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports